import { useQuery } from "react-query";
import { getRoles } from "../services/user/getRoles";
import { PagedRequestType } from "../types/PagedResults";
import { Key_managers } from "../utils/constants";
import { getManagers } from "../services/school/manager/getManagers";

export const useGetManagersQuery = (data: PagedRequestType, options:any=null) =>
  useQuery(
    [Key_managers, JSON.stringify(data)],
    () => getManagers(data), 
    options?{...options}:{}
  );